import { TabConfig } from '~/ui/components'

const tabConfigs: TabConfig[] = [
  {
    label: 'DATOS PERSONALES',
    value: 'personal',
    disabled: false,
  },
  // {
  //   label: 'PEDIDOS',
  //   value: 'orders',
  //   disabled: false,
  // },
  // {
  //   label: 'FACTURACIÓN',
  //   value: 'billing',
  //   disabled: false,
  // },
  // {
  //   label: 'REGISTRO',
  //   value: 'historic',
  //   disabled: false,
  // },
]

export default tabConfigs
